import { useQueryClient } from '@tanstack/react-query';
import { mainCategoryServices } from '../services/main-category.service';

export const usePrefetchMainCategories = () => {
  const queryClient = useQueryClient();

  const prefetchMainCategories = (params) => {
    queryClient.prefetchQuery({
      queryKey: ['main-category', params],
      queryFn: () => mainCategoryServices.getMainCategories(params),
      staleTime: 5 * 60 * 1000,
    });
  };

  const prefetchNextPage = (currentParams, totalPages) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage < totalPages) {
      prefetchMainCategories({ ...currentParams, page: String(currentPage + 1) });
    }
  };

  const prefetchPrevPage = (currentParams) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage > 1) {
      prefetchMainCategories({ ...currentParams, page: String(currentPage - 1) });
    }
  };

  return {
    prefetchMainCategories,
    prefetchNextPage,
    prefetchPrevPage,
  };
};
